/* eslint-disable security/detect-object-injection */
/* eslint-disable no-param-reassign */
import React, {
    useCallback, useMemo, useContext
} from 'react';
import _ from 'lodash';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { withRouter } from 'react-router-dom';
import { TranslatorContext } from '@jutro/locale';
import { CurrencyField, DropdownSelectField } from '@jutro/legacy/components';
import styles from './RevenueTableComponent.module.scss';
import metadata from './RevenueTableComponent.metadata.json5';

function RevenueTableComponent(props) {

    const {
        data: RevenueTableVM,
        updateWizardData,
        submissionVM
    } = props;
    const translator = useContext(TranslatorContext);


    const handleValueChange = useCallback(
        () => {
            updateWizardData(submissionVM);
        },
        [submissionVM, updateWizardData]
    );

    const getTableCell = useCallback(
        // eslint-disable-next-line @typescript-eslint/no-shadow, consistent-return
        (item, index, props) => {
            const { path } = props;

            if (path === 'opecouFie') {
                const value = (item && item.opecouFie) ? item.opecouFie : undefined;
                const availableValues = RevenueTableVM.length > 0 && RevenueTableVM.children[index].opecouFie
                    ? RevenueTableVM.children[index].opecouFie.aspects.availableValues
                        .map((typeCode) => ({
                            code: typeCode.code,
                            name: translator({
                                id: typeCode.name,
                                defaultMessage: typeCode.name
                            })
                        }))
                    : [];

                return (
                    <DropdownSelectField
                        id={index + path}
                        className={styles.coverageForm}
                        onValueChange={(val, changedPath) => {
                            item.opecouFie = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        dataType="string"
                        path={path}
                        value={value}
                        availableValues={availableValues}
                        searchable
                        readOnly
                    />
                );
            }

            if (path === 'revofthelasfinfisyyeaFie') {
                const value = item.revofthelasfinfisyyeaFie ? item.revofthelasfinfisyyeaFie : 0;

                return (
                    <CurrencyField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="number"
                        onValueChange={(val, changedPath) => {
                            item.revofthelasfinfisyyeaFie = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                    />
                );
            }

        }, [handleValueChange, translator, RevenueTableVM])

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const getTotRevFie = () => {
        let total = 0;

        _.each(RevenueTableVM.value, (val) => {
            if (!_.isString(val.revofthelasfinfisyyeaFie)) {
                total += val.revofthelasfinfisyyeaFie;
            }
        });
        _.set(submissionVM, 'lobData.cybLiaLine.coverables.commercialCoverable.business.totRevFie.value', total);

        return total;
    };

    const overrideProps = useMemo(() => ({
        '@field': {
            showOptional: false,
            showRequired: true
        },
        'RevenueTableTable': {
            data: RevenueTableVM.value
        },
        totRevFie: {
            value: `$ ${getTotRevFie()}`,
            readOnly: true
        },

    }), [RevenueTableVM.value, getTotRevFie])

    const resolvers = {
        resolveCallbackMap: {
            getTableCell,
        }
    };

    const readValue = useCallback(
        (fieldId, fieldPath) => readViewModelValue(
            metadata.pageContent,
            RevenueTableVM,
            fieldId,
            fieldPath,
            overrideProps
        ),
        [RevenueTableVM, overrideProps]
    );

    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            model={RevenueTableVM}
            overrideProps={overrideProps}
            resolveValue={readValue}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );


}

RevenueTableComponent.propTypes = wizardProps;
export default withRouter(RevenueTableComponent);
